import { createActionNamespace } from 'Modules/core/redux';

import {
    DownloadExcelType,
    GetCompaniesType,
    SetCompaniesType,
    StatusType,
    ChangeRegisterStageType,
    ChangeRegistersStageType,
    ConfirmRegisterType,
    DownloadAdditionalDocumentsActionType,
    SetNotifications,
} from './types';


const bappAction = createActionNamespace('bapp');

export const bappActions = {
    downloadExcel: bappAction<DownloadExcelType>('DOWNLOAD_EXCEL'),
    downloadAdditionalDocuments: bappAction<DownloadAdditionalDocumentsActionType>('DOWNLOAD_ADDITIONAL_DOCUMENTS'),
    getCompanies: bappAction.withPath<GetCompaniesType>('GET_COMPANIES'),
    setCompanies: bappAction.withPath<SetCompaniesType>('SET_COMPANIES'),
    changeCompaniesSelectMenuState: bappAction.withPath<boolean>('CHANGE_COMPANIES_SELECT_MENU_STATE'),
    setStatus: bappAction<StatusType>('SET_STATUS'),
    changeRegisterStage: bappAction<ChangeRegisterStageType>('CHANGE_REGISTER_STAGE'),
    changeRegistersStage: bappAction<ChangeRegistersStageType>('CHANGE_REGISTERS_STAGE'),
    confirm: bappAction<ConfirmRegisterType>('CONFIRM'),
    getNotifications: bappAction<void>('GET_NOTIFICATIONS'),
    setNotifications: bappAction<SetNotifications>('SET_NOTIFICATIONS'),
};
